import React, { useEffect, useState } from 'react';
import { TestDetails } from './TestDetails';
import { ImagePerformanceChart } from './ImagePerformanceChart';
import { ImagePerformanceTable } from './ImagePerformanceTable';
import { MetricsOverview } from './MetricsOverview';
import { StatisticalMatrix } from './StatisticalMatrix';
import { AssetAnalysis } from './AssetAnalysis';
import { KeyInsights } from './KeyInsights';
import { DemographicCharts } from './DemographicCharts';
import { Toast } from './Toast';
import { mockImageData } from '../utils/mockData';
import { TrophyIcon } from 'lucide-react';
interface DashboardProps {
  timeRange: string;
}
export const Dashboard: React.FC<DashboardProps> = () => {
  const [showToast, setShowToast] = useState(false);
  const data = mockImageData;
  useEffect(() => {
    // Reset localStorage for testing
    localStorage.removeItem('hasShownNotification');
    // Small delay to ensure component is mounted
    const timer = setTimeout(() => {
      if (window.innerWidth <= 1024) {
        setShowToast(true);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="space-y-6 relative" data-id="element-116" data-mp="1vu8182f9j0xj">
      <Toast show={showToast} onClose={() => setShowToast(false)} data-id="element-117" data-mp="1vrvkttp5kyml" />
      <div id="overview" data-id="element-118" data-mp="1gvnsu77i6swr">
        <div className="mb-10" data-id="element-119" data-mp="1gwfo1gx6uomi">
          <div className="text-[#D1005D] text-xs font-bold tracking-[0.1em] uppercase mb-3" data-id="element-120" data-mp="1lvigm1vzf2dl">
            MEASUREMENT REPORT
          </div>
          <h1 className="text-5xl md:text-7xl font-light text-white flex items-center flex-wrap gap-4" data-id="element-121" data-mp="183lse8xfpcmh">
            Lagardère
            <span className="inline-flex items-center px-3 py-1 rounded-sm text-sm font-medium bg-[#D1005D] text-white ml-2 align-middle" data-id="element-122" data-mp="1cx6t48qewkpd">
              Completed
            </span>
          </h1>
        </div>
        <h2 className="text-lg font-medium text-white mb-4" data-id="element-123" data-mp="132y2jqkxz1tu">Test Details</h2>
        <TestDetails data={data} data-id="element-124" data-mp="p61axmx01gbw" />
      </div>
      <div id="performance" data-id="element-125" data-mp="t6v0slu0557f">
        <h2 className="text-lg font-medium text-white mb-4" data-id="element-126" data-mp="t61s3fbhg5mn">
          Performance Overview
        </h2>
        <MetricsOverview data={data} demographicData={{
        genderData: {
          male: 48.2,
          female: 51.8,
          other: 0
        },
        ageData: {
          '18-24': 12.5,
          '25-34': 28.6,
          '35-44': 24.9,
          '45-54': 18.6,
          '55-64': 10.4,
          '65+': 5.0,
          unknown: 0
        }
      }} data-id="element-127" data-mp="2vujw371lg5iy" />
      </div>
      <div id="analysis" data-id="element-128" data-mp="39tt0zakcnd7m">
        <div className="flex items-center mb-4" data-id="element-129" data-mp="39ukxqopongzh">
          <h2 className="text-lg font-medium text-white mr-3" data-id="element-130" data-mp="39rqdoyakzy6l">
            Detailed Asset Analysis
          </h2>
          <div className="flex items-center bg-[#D1005D] text-white px-3 py-1.5 rounded-sm shadow-sm" data-id="element-131" data-mp="30t4wb6guip7e">
            <TrophyIcon className="h-4 w-4 mr-1.5" data-id="element-132" data-mp="1tf1jvtsnlsdm" />
            <span className="text-xs font-bold uppercase tracking-wide" data-id="element-133" data-mp="1tgmchdver18u">
              Winner: Red Background
            </span>
          </div>
        </div>
        <AssetAnalysis data={data} data-id="element-134" data-mp="4w6zomjgseki" />
      </div>
      <div id="statistics" data-id="element-135" data-mp="4xi50qsk5udq">
        <h2 className="text-lg font-medium text-white mb-4" data-id="element-136" data-mp="8x8tuoyiy0fm">
          Statistical Analysis
        </h2>
        <StatisticalMatrix data={data} data-id="element-137" data-mp="dwlqg1f76lve" />
      </div>
      <div id="recommendations" data-id="element-138" data-mp="dusjsm4l41ne">
        <KeyInsights data-id="element-139" data-mp="in22pi7a81g6" />
      </div>
    </div>;
};